import React from 'react';
import styled from 'styled-components';
import { PJC } from './Raising Jobs/PJC';
import { useState, useEffect } from 'react';

const images = [
  "/Frame 3.png",
  "/Frame 10.png",
  "/Frame 8.png",
  "/Frame 7.png"
];


const HeroSection = styled.section`
  width: 95%;
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: flex-start;
  padding: 2.25rem;
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  position: relative; /* To ensure stacking context */
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.1);
  border: 1px solid #d7e6f8;
  margin-bottom: 2.25rem;
  overflow: visible;

  @media (max-width: 768px) {
    padding: 1.25rem;
  }
`;




const Container = styled.div`
  width: 100%;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.4rem;
  position: relative;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 2.2rem;
  }
`;

const LeftSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center; /* Center horizontally */
  justify-content: center; /* Center vertically */
  text-align: center; /* Center text */
  color: #1e3a8a;

  @media (min-width: 768px) {
    align-items: center; /* Keep it centered on larger screens */
    text-align: center;
  }
`;

const CenteredPJCWrapper = styled.div`
  display: flex;
  justify-content: center; /* Horizontal centering */
  align-items: center; /* Vertical centering */
  width: 100%;
`;

const Title = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: clamp(1.7rem, 4vw, 2.4rem);
  font-weight: 700;
  line-height: 1.15;
  margin-bottom: 0.9rem;
  color: #0b3d73;
  text-align: center;
  letter-spacing: -0.02em;
  text-wrap: balance;

  @media (min-width: 768px) {
    font-size: clamp(2rem, 2.6vw, 2.5rem);
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;






const Subtitle = styled.p`
  font-size: clamp(1rem, 2.3vw, 1.15rem);
  margin: 0 auto 1.2rem auto;
  color: #1b5ca3;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 500;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const RightSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  /* Prevent shrinkage */
  min-width: 320px;
  max-width: 400px;
`;


const Image = styled.img`
  max-width: 320px;
  height: auto;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  @media (max-width: 768px) {
    max-width: 280px;
  }

  @media (max-width: 480px) {
    max-width: 220px;
  }
`;

const ImageSliderWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 320px;
  aspect-ratio: 3 / 4;
  border-radius: 2rem;
  overflow: hidden;
  border: 1px solid #d7e6f8;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
  
  background-color: transparent;
  padding: 0;
  margin: 0;
  line-height: 0; /* 🔥 Remove inline spacing ghost lines from img */

  @media (max-width: 768px) {
    max-width: 280px;
  }

  @media (max-width: 480px) {
    max-width: 220px;
  }
`;




const FadingImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* fills container fully with no white */
  border-radius: 1.5rem;
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: opacity 2.5s ease-in-out;
  margin: 0;
  padding: 0;
  display: block;
`;




function Hero({ formState, setFormState }) {

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000); // Change every 4 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <HeroSection>
      <Container>
        <LeftSection>
          <Title>Find Trusted Local Tradespeople Today!</Title>
          <Subtitle>Post your job in under 2 minutes.</Subtitle>
          <CenteredPJCWrapper>
            <PJC formState={formState} setFormState={setFormState} />
          </CenteredPJCWrapper>
        </LeftSection>
        <RightSection>
  <ImageSliderWrapper>
    {images.map((src, index) => (
      <FadingImage
        key={index}
        src={src}
        alt={`TradesUTrust app preview slide ${index + 1}`}
        active={index === currentImage}
        loading={index === 0 ? 'eager' : 'lazy'}
        decoding="async"
        fetchPriority={index === 0 ? 'high' : 'low'}
      />
    ))}
  </ImageSliderWrapper>
</RightSection>
      </Container>
    </HeroSection>
  );
}

export default Hero;
